export default function districtStyle(state, feature) {
  let fillOpacity = 1;
  let fillColor = "#333";
  let { sub } = feature.properties;
  if (state.districtNumber) {
    fillOpacity = sub == state.districtNumber ? 1 : .3;
  }
  switch (state.districtColor) {
    case "term": {
      fillColor = state.districts?.[sub].term == 2 ? "var(--two-year)" : "var(--four-year)";
      break;
    }

    case "demographic": {
      let majority = state.districts?.[sub].majority || "default";
      fillColor = `var(--${majority})`;
      break;
    }

    case "census": {
      let majority = state.districts?.[sub].census.majority || "default";
      fillColor = `var(--${majority})`;
      break;
    }

  }
  return {
    fillColor,
    fillOpacity,
    weight: 1,
    color: "#000C",
  }
}